function initiateEvolutionsStep(evolution) {
  // const { description, signSymptom } = evolution;

  return evolution || null;
}

export { initiateEvolutionsStep };
